import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import Icon from '../../../icons/components/Icon';
import { withPixelLineHeight } from '../../../styles/functions.web';
import { COLORS } from '../../constants';
import AbstractLabel from '../AbstractLabel';
/**
 * Creates the styles for the component.
 *
 * @param {Object} theme - The current UI theme.
 *
 * @returns {Object}
 */
const styles = (theme) => {
    return {
        label: Object.assign(Object.assign({}, withPixelLineHeight(theme.typography.labelRegular)), { alignItems: 'center', background: theme.palette.ui04, borderRadius: theme.shape.borderRadius / 2, color: theme.palette.text01, display: 'flex', height: 28, margin: '0 0 4px 4px', padding: '0 8px' }),
        withIcon: {
            marginLeft: 8
        },
        clickable: {
            cursor: 'pointer'
        },
        [COLORS.white]: {
            background: theme.palette.text01,
            color: theme.palette.ui04,
            '& svg': {
                fill: theme.palette.ui04
            }
        },
        [COLORS.green]: {
            background: theme.palette.success02
        },
        [COLORS.red]: {
            background: theme.palette.actionDanger
        }
    };
};
/**
 * React Component for showing short text in a circle.
 *
 * @augments Component
 */
class Label extends AbstractLabel {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        const { classes, className, color, icon, iconColor, id, onClick, text } = this.props;
        const labelClassName = clsx(classes.label, onClick && classes.clickable, color && classes[color], className);
        return (React.createElement("div", { className: labelClassName, id: id, onClick: onClick },
            icon && React.createElement(Icon, { color: iconColor, size: '16', src: icon }),
            text && React.createElement("span", { className: icon && classes.withIcon }, text)));
    }
}
export default withStyles(styles)(Label);
